import React, {useEffect, useState} from "react";
import { Alert } from "antd";

export default function DetectGoogleBlock() {
    const [googleBlocked, setGoogleBlocked] = useState(false);

    useEffect(() => {
        const urlsToCheck = [
            "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
            "https://www.google-analytics.com/analytics.js",
            "https://www.googletagmanager.com/gtm.js",
        ];

        const checkBlocked = async (url) => {
            try {
                const controller = new AbortController();
                const timeout = setTimeout(() => controller.abort(), 2000); // 2 segundos timeout

                const response = await fetch(url, { method: "HEAD", mode: "no-cors", signal: controller.signal });
                clearTimeout(timeout);

                // Si la petición falla o es bloqueada, vamos a considerarlo bloqueado
                return false; // HEAD no-cors no garantiza status, asumimos cargado
            } catch (err) {
                return true; // error = bloqueado
            }
        };

        (async () => {
            for (let url of urlsToCheck) {
                const blocked = await checkBlocked(url);
                if (blocked) {
                    setGoogleBlocked(true);
                    break;
                }
            }
        })();
    }, []);

    if (!googleBlocked) return null;

    return (
        <Alert
            message="Bloqueador de anuncios detectado"
            description="Detectamos que uno o más servicios de Google podrían estar bloqueados. Para una mejor experiencia, desactívalo."
            type="warning"
            showIcon
        />
    );
}